import { Component, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';

import { I18nService } from '../../services/i18n.service';
import { ServiceConditionService } from '../../services/service-condition.service';

@Component({
  selector: 'app-service-conditions-modal',
  imports: [NzModalModule, NzButtonModule, NzIconModule],
  templateUrl: './service-conditions-modal.html',
  styleUrls: ['./service-conditions-modal.scss'],
})
export class ServiceConditionsModalComponent {
  readonly isVisible = signal(true);

  public i18n = inject(I18nService);
  private router = inject(Router);
  private serviceConditionService = inject(ServiceConditionService);

  close(): void {
    this.serviceConditionService
      .dismissBannerNotification({
        BannerType: 'consent',
      })
      .subscribe({
        next: () => this.isVisible.set(false),
      });
    this.isVisible.set(false);
  }

  redirectToServiceCondition(): void {
    this.router.navigate(['/service-conditions-updated']);
  }

  acceptAndContinue(): void {
    this.serviceConditionService
      .acceptServiceCondition({
        BannerType: 'consent',
      })
      .subscribe({
        next: () => {
          this.isVisible.set(false);
        },
      });
    this.isVisible.set(false);
  }

  acceptLater(): void {
    this.serviceConditionService
      .dismissBannerNotification({
        BannerType: 'consent',
      })
      .subscribe({
        next: () => this.isVisible.set(false),
      });
    this.isVisible.set(false);
  }

  open(): void {
    this.isVisible.set(true);
  }
}
